import { render, staticRenderFns } from "./ProductsListing.vue?vue&type=template&id=7c974e8c&scoped=true&"
import script from "./ProductsListing.vue?vue&type=script&lang=js&"
export * from "./ProductsListing.vue?vue&type=script&lang=js&"
import style0 from "./ProductsListing.vue?vue&type=style&index=0&id=7c974e8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c974e8c",
  null
  
)

export default component.exports